import { useQuery } from 'react-query';
import { 
    NIBUD_OPTIONS_CAR_KILOMETERS_ENDPOINT,
    NIBUD_OPTIONS_CAR_STATUS_ENDPOINT,
    NIBUD_OPTIONS_CAR_TYPE_ENDPOINT,
    NIBUD_OPTIONS_GENDER_ENDPOINT,
    NIBUD_OPTIONS_HOME_ENDPOINT,
    NIBUD_OPTIONS_HOME_TYPE_ENDPOINT,
    NIBUD_OPTIONS_HOME_WOZ_ENDPOINT,
    SECONDARY_NIBUD_API_KEY,
    twentyFourHoursInMs 
} from '../../config/nibud';
import { apifetch, RiskProfile } from '../robotapi';

export interface RiskProfileResponse {
    data: RiskProfile[];
}

export type NibudPensionResponeType = {
    usedvalue: null,
    value: string,
    name: string,
}

export const useGetNibudGenderOptions = () => {
    return useGetNibudOptionsBase(NIBUD_OPTIONS_GENDER_ENDPOINT);
};
export const useGetNibudCarKilometersOptions = () => {
    return useGetNibudOptionsBase(NIBUD_OPTIONS_CAR_KILOMETERS_ENDPOINT);
};
export const useGetNibudCarStatusOptions = () => {
    return useGetNibudOptionsBase(NIBUD_OPTIONS_CAR_STATUS_ENDPOINT);
};
export const useGetNibudHomeOptions = () => {
    return useGetNibudOptionsBase(NIBUD_OPTIONS_HOME_ENDPOINT);
};
export const useGetNibudCarTypeOptions = () => {
    return useGetNibudOptionsBase(NIBUD_OPTIONS_CAR_TYPE_ENDPOINT);
};
export const useGetNibudHomeWOZOptions = () => {
    return useGetNibudOptionsBase(NIBUD_OPTIONS_HOME_WOZ_ENDPOINT);
};
export const useGetNibudHomeType = () => {
    return useGetNibudOptionsBase(NIBUD_OPTIONS_HOME_TYPE_ENDPOINT);
};

const useGetNibudOptionsBase = (endpoint: string) => {
    const NibudOptionsQuery = useQuery<NibudPensionResponeType[]>( endpoint,
        async () => {
            const getNibudGenderOptions = apifetch<NibudPensionResponeType[]>(endpoint, "GET", {
                    "Ocp-Apim-Subscription-Key" : SECONDARY_NIBUD_API_KEY,
                }
            );
            return getNibudGenderOptions();
        },
        {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            staleTime: twentyFourHoursInMs,
        }

    );

    return NibudOptionsQuery;
};